export default __webpack_public_path__ + "media/images/react_icons/property/bed-b433b38bf07405f897c1f1dce71198ab.svg";